import apiClient from "../baseUrl/axiosConfig";

export const getGeneralSection = async (slug) => {
  const response = await apiClient.get(`/pages/${slug}`);
  return response.data.sections.general_section;
};
